const fetchEquip = {
  text: 'Nenhum resultado encontrado'
}

export default fetchEquip;
